//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useNavigate } from "react-router-dom";

//context
import { AuthContext } from "../../../../context/AuthContext";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";

//interfaces
import { PersonaPrueba } from "../../../../interfaces/PersonaPruebaInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import { toast } from "react-toastify";

//estilos
const classes = require("./PersonaPruebaTable.module.css").default;

const PersonaPruebaTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [personaPrueba, setPersonaPrueba] = useState<PersonaPrueba[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata las personas en prueba traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setPersonaPrueba(variable.data);
  }, []);

  //Función que llama todas las personas en prueba paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/persona_prueba",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Función que desactiva a un personas en prueba.
  const changePersonaPruebaStatus = useCallback(
    (idVerificacion: number) => {
      if (
        window.confirm(
          "¿Seguro que desea cambiar el estatus de la  persona en prueba?"
        )
      ) {
        sendRequest(
          {
            url: `/persona_prueba/${idVerificacion}`,
            method: "DELETE",
          },
          (variable: any) => {
            setPersonaPrueba([]);
            toast.success("La persona en prueba ha cambiado de estatus.", {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            sendRequest(
              {
                url: "/persona_prueba",
              },
              transformData
            );
          }
        );
      }
    },
    [sendRequest, transformData]
  );

  const columns = useMemo<ColumnDef<PersonaPrueba>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Estatus",
        cell: (info) => info.getValue(),
        accessorFn: (row) => (row.estatus ? "Activo" : "Inactivo"),
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar persona en prueba"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(
                  `/main/catalogos/personaPrueba/edit/${info.row.original.id}`
                )
              }
              disabled={!authContext.tokenCan("PersonaPrueba:update")}
            >
              <FontAwesomeIcon icon={faPen as IconProp} />
            </Button>
            {/** Botón para ver eliminar*/}
            <Button
              title={
                info.row.original.estatus
                  ? "Deshabilitar persona en prueba"
                  : "Habilitar persona en prueba"
              }
              style={{ backgroundColor: "#0d5475", borderColor: "white" }}
              disabled={!authContext.tokenCan("PersonaPrueba:delete")}
              onClick={() => changePersonaPruebaStatus(info.row.original.id)}
            >
              <FontAwesomeIcon
                icon={(info.row.original.estatus ? faToggleOn : faToggleOff) as IconProp}
              />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [changePersonaPruebaStatus, navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!personaPrueba) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de personas en prueba</h2>
      {/** Botón para agregar persona en prueba */}
      {authContext.tokenCan("PersonaPrueba:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar una nueva persona en prueba"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/personaPrueba/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus as IconProp} /> Nueva persona en prueba
          </Button>
        </div>
      )}

      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: personaPrueba,
          columns,
        }}
      />
    </Container>
  );
};

export default PersonaPruebaTable;
